import React from "react";
import { useTranslation } from "react-i18next";
import styles from "../CRMSettingsPage.module.css";

export default function EmailTab({
  emailMode,
  setEmailMode,
  replyToEmployee,
  setReplyToEmployee,
  corporateFromEmail,
  setCorporateFromEmail,
  corporateFromName,
  setCorporateFromName,
  smtpHost,
  setSmtpHost,
  smtpPort,
  setSmtpPort,
  smtpUser,
  setSmtpUser,
  smtpPassword,
  setSmtpPassword,
  smtpTls,
  setSmtpTls,
  imapHost,
  setImapHost,
  imapPort,
  setImapPort,
  imapUser,
  setImapUser,
  imapPassword,
  setImapPassword,
  imapSsl,
  setImapSsl,
  emailInnerTab,
  setEmailInnerTab,
}) {
  const { t } = useTranslation();

  return (
    <div className={styles.emailShell}>
      <div className={styles.emailHeader}>
        <div>
          <div className={styles.emailTitle}>
            {t("crm_settings_tab_email", { defaultValue: "Email" })}
          </div>
          <div className={styles.emailHint}>
            {t("crm_settings_email_hint", {
              defaultValue: "Tenant email delivery and sync settings.",
            })}
          </div>
        </div>
      </div>

      <div className={styles.emailGrid2}>
        <div className={styles.emailCard}>
          <div className={styles.emailCardHead}>
            <div className={styles.emailCardTitle}>
              {t("crm_settings_email_general", {
                defaultValue: "General",
              })}
            </div>
            <span className={styles.pill}>
              {t("crm_settings_tenant", { defaultValue: "Tenant" })}
            </span>
          </div>

          <div className={styles.formCol}>
            <div className={styles.field}>
              <div className={styles.labelRow}>
                <div className={styles.fLabel}>
                  {t("crm_settings_email_mode", {
                    defaultValue: "Email mode",
                  })}
                </div>
              </div>
              <select
                className={styles.ctrl}
                value={emailMode}
                onChange={(e) => setEmailMode(e.target.value)}
              >
                <option value="corporate">
                  {t("crm_settings_email_mode_corporate", {
                    defaultValue: "Corporate",
                  })}
                </option>
                <option value="hybrid">
                  {t("crm_settings_email_mode_hybrid", {
                    defaultValue: "Hybrid",
                  })}
                </option>
                <option value="employee">
                  {t("crm_settings_email_mode_employee", {
                    defaultValue: "Employee",
                  })}
                </option>
              </select>
            </div>

            <div className={styles.field}>
              <div className={styles.labelRow}>
                <div className={styles.fLabel}>
                  {t("crm_settings_reply_to_employee", {
                    defaultValue: "Reply to employee",
                  })}
                </div>
                <div className={styles.fHelp}>
                  {t("crm_settings_email_mode_hybrid", {
                    defaultValue: "Hybrid",
                  })}
                </div>
              </div>

              <div className={styles.toggle}>
                <div className={styles.toggleLeft}>
                  <input
                    type="checkbox"
                    checked={replyToEmployee}
                    onChange={(e) => setReplyToEmployee(e.target.checked)}
                  />
                  <span
                    className={styles.fLabel}
                    style={{ opacity: 0.9, fontWeight: 700 }}
                  >
                    {replyToEmployee
                      ? t("crm_settings_on", { defaultValue: "On" })
                      : t("crm_settings_off", { defaultValue: "Off" })}
                  </span>
                </div>
              </div>
            </div>

            <div className={styles.field}>
              <div className={styles.labelRow}>
                <div className={styles.fLabel}>
                  {t("crm_settings_email_from", {
                    defaultValue: "From email",
                  })}
                </div>
                <div className={styles.fHelp}>
                  {t("crm_settings_from_email_hint", {
                    defaultValue: "Visible sender address",
                  })}
                </div>
              </div>
              <input
                className={styles.ctrl}
                value={corporateFromEmail}
                onChange={(e) => setCorporateFromEmail(e.target.value)}
                placeholder={t("email_input_placeholder", {
                  defaultValue: "email@company.com",
                })}
              />
            </div>

            <div className={styles.field}>
              <div className={styles.labelRow}>
                <div className={styles.fLabel}>
                  {t("crm_settings_from_name", {
                    defaultValue: "From name",
                  })}
                </div>
              </div>
              <input
                className={styles.ctrl}
                value={corporateFromName}
                onChange={(e) => setCorporateFromName(e.target.value)}
                placeholder={t("crm_settings_from_name_placeholder", {
                  defaultValue: "Company team",
                })}
              />
            </div>

            <div className={styles.field}>
              <div className={styles.labelRow}>
                <div className={styles.fLabel}>
                  {t("crm_settings_quick_switch", {
                    defaultValue: "Quick switch",
                  })}
                </div>
                <div className={styles.fHelp}>SMTP / IMAP</div>
              </div>

              <div className={styles.innerTabs} style={{ marginBottom: 0 }}>
                <button
                  type="button"
                  className={`${styles.innerTab} ${
                    emailInnerTab === "smtp" ? styles.innerTabActive : ""
                  }`}
                  onClick={() => setEmailInnerTab("smtp")}
                >
                  SMTP
                </button>
                <button
                  type="button"
                  className={`${styles.innerTab} ${
                    emailInnerTab === "imap" ? styles.innerTabActive : ""
                  }`}
                  onClick={() => setEmailInnerTab("imap")}
                >
                  IMAP
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.emailCard}>
          <div className={styles.emailCardHead}>
            <div className={styles.emailCardTitle}>
              {t("crm_settings_connection", {
                defaultValue: "Connection",
              })}
            </div>
            <span className={styles.pill}>
              {emailInnerTab === "smtp"
                ? t("crm_settings_outgoing", { defaultValue: "Outgoing" })
                : t("crm_settings_incoming", { defaultValue: "Incoming" })}
            </span>
          </div>

          <div className={styles.innerTabs}>
            <button
              type="button"
              className={`${styles.innerTab} ${
                emailInnerTab === "smtp" ? styles.innerTabActive : ""
              }`}
              onClick={() => setEmailInnerTab("smtp")}
            >
              SMTP
            </button>
            <button
              type="button"
              className={`${styles.innerTab} ${
                emailInnerTab === "imap" ? styles.innerTabActive : ""
              }`}
              onClick={() => setEmailInnerTab("imap")}
            >
              IMAP
            </button>
          </div>

          {emailInnerTab === "smtp" ? (
            <div className={styles.formCol}>
              <div className={styles.field}>
                <div className={styles.labelRow}>
                  <div className={styles.fLabel}>
                    {t("account_smtp_host", {
                      defaultValue: "SMTP host",
                    })}
                  </div>
                </div>
                <input
                  className={styles.ctrl}
                  value={smtpHost}
                  onChange={(e) => setSmtpHost(e.target.value)}
                  placeholder="smtp.gmail.com"
                />
              </div>

              <div className={styles.row2}>
                <div className={styles.field}>
                  <div className={styles.labelRow}>
                    <div className={styles.fLabel}>
                      {t("account_smtp_port", {
                        defaultValue: "SMTP port",
                      })}
                    </div>
                  </div>
                  <input
                    className={styles.ctrl}
                    type="number"
                    value={smtpPort}
                    onChange={(e) => setSmtpPort(e.target.value)}
                    placeholder="587"
                  />
                </div>

                <div className={styles.field}>
                  <div className={styles.labelRow}>
                    <div className={styles.fLabel}>
                      {t("account_tls", { defaultValue: "TLS" })}
                    </div>
                  </div>
                  <div className={styles.toggle}>
                    <div className={styles.toggleLeft}>
                      <input
                        type="checkbox"
                        checked={smtpTls}
                        onChange={(e) => setSmtpTls(e.target.checked)}
                      />
                      <span
                        className={styles.fLabel}
                        style={{ opacity: 0.9, fontWeight: 700 }}
                      >
                        {smtpTls
                          ? t("crm_settings_on", { defaultValue: "On" })
                          : t("crm_settings_off", {
                              defaultValue: "Off",
                            })}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <details className={styles.adv}>
                <summary>{t("advanced", { defaultValue: "Advanced" })}</summary>

                <div className={styles.formCol} style={{ marginTop: 10 }}>
                  <div className={styles.field}>
                    <div className={styles.labelRow}>
                      <div className={styles.fLabel}>
                        {t("account_smtp_user", {
                          defaultValue: "SMTP user",
                        })}
                      </div>
                    </div>
                    <input
                      className={styles.ctrl}
                      value={smtpUser}
                      onChange={(e) => setSmtpUser(e.target.value)}
                      placeholder={t("email_input_placeholder", {
                        defaultValue: "email@company.com",
                      })}
                    />
                  </div>

                  <div className={styles.field}>
                    <div className={styles.labelRow}>
                      <div className={styles.fLabel}>
                        {t("account_smtp_password", {
                          defaultValue: "SMTP password",
                        })}
                      </div>
                    </div>
                    <input
                      className={styles.ctrl}
                      type="password"
                      value={smtpPassword}
                      onChange={(e) => setSmtpPassword(e.target.value)}
                      placeholder={t("crm_settings_change_me", {
                        defaultValue: "Change me",
                      })}
                    />
                  </div>
                </div>
              </details>
            </div>
          ) : (
            <div className={styles.formCol}>
              <div className={styles.field}>
                <div className={styles.labelRow}>
                  <div className={styles.fLabel}>
                    {t("crm_settings_imap_host", {
                      defaultValue: "IMAP host",
                    })}
                  </div>
                </div>
                <input
                  className={styles.ctrl}
                  value={imapHost}
                  onChange={(e) => setImapHost(e.target.value)}
                  placeholder="imap.gmail.com"
                />
              </div>

              <div className={styles.row2}>
                <div className={styles.field}>
                  <div className={styles.labelRow}>
                    <div className={styles.fLabel}>
                      {t("crm_settings_imap_port", {
                        defaultValue: "IMAP port",
                      })}
                    </div>
                  </div>
                  <input
                    className={styles.ctrl}
                    type="number"
                    value={imapPort}
                    onChange={(e) => setImapPort(e.target.value)}
                    placeholder="993"
                  />
                </div>

                <div className={styles.field}>
                  <div className={styles.labelRow}>
                    <div className={styles.fLabel}>
                      {t("crm_settings_imap_ssl", {
                        defaultValue: "IMAP SSL",
                      })}
                    </div>
                  </div>
                  <div className={styles.toggle}>
                    <div className={styles.toggleLeft}>
                      <input
                        type="checkbox"
                        checked={imapSsl}
                        onChange={(e) => setImapSsl(e.target.checked)}
                      />
                      <span
                        className={styles.fLabel}
                        style={{ opacity: 0.9, fontWeight: 700 }}
                      >
                        {imapSsl
                          ? t("crm_settings_on", { defaultValue: "On" })
                          : t("crm_settings_off", {
                              defaultValue: "Off",
                            })}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <details className={styles.adv}>
                <summary>{t("advanced", { defaultValue: "Advanced" })}</summary>

                <div className={styles.formCol} style={{ marginTop: 10 }}>
                  <div className={styles.field}>
                    <div className={styles.labelRow}>
                      <div className={styles.fLabel}>
                        {t("crm_settings_imap_user", {
                          defaultValue: "IMAP user",
                        })}
                      </div>
                    </div>
                    <input
                      className={styles.ctrl}
                      value={imapUser}
                      onChange={(e) => setImapUser(e.target.value)}
                      placeholder={t("email_input_placeholder", {
                        defaultValue: "email@company.com",
                      })}
                    />
                  </div>

                  <div className={styles.field}>
                    <div className={styles.labelRow}>
                      <div className={styles.fLabel}>
                        {t("crm_settings_imap_password", {
                          defaultValue: "IMAP password",
                        })}
                      </div>
                    </div>
                    <input
                      className={styles.ctrl}
                      type="password"
                      value={imapPassword}
                      onChange={(e) => setImapPassword(e.target.value)}
                      placeholder={t("crm_settings_change_me", {
                        defaultValue: "Change me",
                      })}
                    />
                  </div>
                </div>
              </details>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}